import React, { useEffect, useState } from "react";
import api from "./../../../api";
import "components/formalities/admin/css/admin-formalities.css";
const assetsPath =
  "https://formalites.fortium.fr/msmedias/.formalities/assets";
export default function AdminPageFormalitiesTemplatesCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const emptyForm = {
    fcSlug: "",
    fcName: "",
    fcSummary: "",
    fcStatus: "active",
    fcIcon: ""
  };
  const [form, setForm] = useState(emptyForm);
  // ----------------------------------------------------
  // Helpers
  // ----------------------------------------------------
  const updateForm = (field) => (value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  const closeModal = () => {
    setShowModal(false);
    setEditing(null);
  };
  // ----------------------------------------------------
  // Load categories
  // ----------------------------------------------------
  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/formalities/categories");
      setCategories(res.data || []);
    } catch (e) {
      console.error("LOAD ERROR", e);
    }
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);
  // ----------------------------------------------------
  // Modal actions
  // ----------------------------------------------------
  const openAdd = () => {
    setEditing(null);
    setForm(emptyForm);
    setShowModal(true);
  };
  const openEdit = (cat) => {
    setEditing(cat);
    setForm({
      fcSlug: cat.fcSlug || "",
      fcName: cat.fcName || "",
      fcSummary: cat.fcSummary || "",
      fcStatus: cat.fcStatus || "inactive",
      fcIcon: cat.fcIcon || ""
    });
    setShowModal(true);
  };
  // ----------------------------------------------------
  // Save
  // ----------------------------------------------------
  const handleSave = async () => {
    const payload = {
      fcSlug: form.fcSlug.trim() || null,
      fcName: form.fcName.trim(),
      fcStatus: form.fcStatus,
      fcSummary: form.fcSummary,
      fcIcon: form.fcIcon.trim()
    };
    try {
      if (editing) {
        await api.put(
          `/admin/formalities/categories/${editing.fcId}`,
          payload
        );
      } else {
        await api.post(`/admin/formalities/categories`, payload);
      }
      closeModal();
      load();
    } catch (e) {
      console.error("SAVE ERROR", e);
    }
  };
  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="h4 m-0">Catégories de formalités</h1>
        <button
          className="btn btn-primary"
          onClick={openAdd}
        >
          Ajouter
        </button>
      </div>
      {loading && (
        <div className="text-muted">
          Chargement…
        </div>
      )}
      {!loading && (
        <div className="list-group shadow-sm">
          {categories.map((cat) => (
            <button
              key={cat.fcId}
              className="list-group-item list-group-item-action"
              onClick={() => openEdit(cat)}
            >
              <div className="row align-items-center g-3">
                {/* Icon */}
                <div className="col-auto">
                  {cat.fcIcon && (
                    <img
                      src={`${assetsPath}/${cat.fcIcon}`}
                      alt=""
                      width="32"
                      height="32"
                      style={{ objectFit: "contain" }}
                    />
                  )}
                </div>
                {/* Name */}
                <div className="col">
                  <div className="fw-bold">
                    {cat.fcName}
                  </div>
                  <div className="small text-muted">
                    {cat.fcSlug}
                  </div>
                </div>
                {/* Status */}
                <div className="col-auto">
                  <span
                    className={`badge bg-${cat.fcStatus === "active"
                      ? "success"
                      : "secondary"
                      }`}
                  >
                    {cat.fcStatus === "active"
                      ? "Active"
                      : "Inactive"}
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
      {/* ----------------------------------------------------
          MODAL
      ---------------------------------------------------- */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title">
                  {editing
                    ? "Modifier une catégorie"
                    : "Ajouter une catégorie"}
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                />
              </div>
              <div className="modal-body">
                {/* Name */}
                <div className="mb-3">
                  <label className="form-label">
                    Nom
                  </label>
                  <input
                    className="form-control"
                    value={form.fcName}
                    onChange={(e) =>
                      updateForm("fcName")(e.target.value)
                    }
                  />
                </div>
                {/* Slug */}
                <div className="mb-3">
                  <label className="form-label">
                    Slug
                  </label>
                  <input
                    className="form-control"
                    placeholder="auto-généré si vide"
                    value={form.fcSlug}
                    onChange={(e) =>
                      updateForm("fcSlug")(e.target.value)
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Résumé</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={form.fcSummary}
                    onChange={(e) =>
                      updateForm("fcSummary")(e.target.value)
                    }
                  />
                  <div className="form-text">
                    Texte court affiché dans certaines pages publiques.
                  </div>
                </div>
                {/* Icon */}
                <div className="mb-3">
                  <label className="form-label">
                    Icône
                  </label>
                  <input
                    className="form-control"
                    value={form.fcIcon}
                    onChange={(e) =>
                      updateForm("fcIcon")(e.target.value)
                    }
                  />
                  <div className="form-text">
                    Exemple : <code>constitution.png</code>
                  </div>
                  {form.fcIcon && (
                    <div className="mt-2">
                      <img
                        src={`${assetsPath}/${form.fcIcon}`}
                        alt=""
                        width="48"
                        height="48"
                        style={{ objectFit: "contain" }}
                      />
                    </div>
                  )}
                </div>
                {/* Status */}
                <div className="mb-3">
                  <label className="form-label">
                    Statut
                  </label>
                  <select
                    className="form-select"
                    value={form.fcStatus}
                    onChange={(e) =>
                      updateForm("fcStatus")(e.target.value)
                    }
                  >
                    <option value="active">
                      Actif
                    </option>
                    <option value="inactive">
                      Inactif
                    </option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={closeModal}
                >
                  Annuler
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={closeModal}
          />
        </div>
      )}
    </div>
  );
}